import departureCity from './fromRouter/departureCity';
import checkInDateRange from './fromRouter/checkInDateRange';
import nightRange from './fromRouter/nightRange';
import priceRange from './fromRouter/priceRange';
import touristGroup from './fromRouter/touristGroup';
import operators from './fromRouter/operators';
import meals from './fromRouter/meals';
import warranted from './fromRouter/warranted';
import directFlights from './fromRouter/directFlights';
import block from './fromRouter/block';

import '@/js/common/plugins/jquery.unparam.min';

export default (urlParams) => {
    const urlQuery = window.location.search?.substring(1);
    const identities = $.unparam(urlQuery)?.identities;
    const identity = $.unparam(urlQuery)?.identity;

    if (typeof urlParams !== 'string') {
        const shortParams = {};
        if (identity) {
            shortParams.identities = [identity];
        }
        if (identities) {
            shortParams.identities = identities;
        }

        return shortParams;
    }

    const params = $.unparam(urlParams);

    const tourCriteria = {
        ...departureCity(params),
        ...checkInDateRange(params),
        ...nightRange(params),
        ...priceRange(params),
        ...touristGroup(params),
        ...operators(params),
        ...meals(params),
        ...warranted(params),
        ...directFlights(params),
        ...block(params),
    };

    let ages;
    if (params.ages) {
        ages = _.values(params.ages);
    }

    let element;

    let activeTab;
    element = params.activeTab;
    if (element) {
        switch (element) {
            case 'tours':
                activeTab = 'tours';
                break;
            case 'hotels':
                activeTab = 'hotels';
                break;
            default:
                activeTab = 'tours';
        }
    }

    let sid;
    element = params.sid;
    if (element) {
        sid = element;
    }

    let hsid;
    element = params.hsid;
    if (element) {
        hsid = element;
    }

    return {
        tourCriteria,
        directFlight: params.directFlight,
        identity,
        identities,
        activeTab,
        sid,
        hsid,
        ages,
        block: params.block,
    };
};